<template>
  <div>
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div class="printContent">
      <div id="print" :contentLoading="contentLoading">
        <div class="printContainer">
          <!-- 打印标签区域 - 每个数据项生成多行相同的标签 -->
          <div v-for="(form,index) in productionOrderList" :key="index" class="dataList" style="margin-bottom: 20px; width: 100%;">
            <div class="qrCodeBox">
              <svg :id="'qrCode'+form.billNo"/>
              <div style="flex: 1;">
                <div class="title">新时达工控技术(杭州)有限公司</div>
                <div class="title smallTitle">{{'委外发料单'}}</div>
              </div>
            </div>
            <el-descriptions border :column="3" :label-style="{'word-break': 'keep-all'}">
              <el-descriptions-item label="委外单号">{{form.billNo}}</el-descriptions-item>
              <el-descriptions-item label="创建日期">{{form.createTime}}</el-descriptions-item>
              <el-descriptions-item label="采购订单号">{{form.purchaseOrderNos}}</el-descriptions-item>
              <el-descriptions-item label="供应商编码">{{form.supplierNo}}</el-descriptions-item>
              <el-descriptions-item label="供应商名称">{{form.supplierName}}</el-descriptions-item>
            </el-descriptions>

            <!-- 使用原生table标签替换el-table -->
            <table
                class="print-table"
                width="100%"
                border="1"
                cellspacing="0"
                cellpadding="5">
              <thead>
                <tr>
                  <th width="50" style="text-align: center;">序号</th>
                  <th width="120" style="text-align: center;">物料编号</th>
                  <th width="102" style="text-align: center;">旧料号</th>
                  <th width="180" style="text-align: center;" class="material-name-col">物料名称</th>
                  <th width="80" style="text-align: center;">仓位</th>
                  <th width="60" style="text-align: center;">工厂库存</th>
                  <th width="60" style="text-align: center;">供应商库存</th>
                  <th width="90" style="text-align: center;">发料数量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in form.details" :key="idx">
                  <td style="text-align: center;">{{idx + 1}}</td>
                  <td style="text-align: center;">{{item.materialNo}}</td>
                  <td style="text-align: center;">{{item.mappingMaterialNo}}</td>
                  <td style="text-align: left;" class="material-name-col">{{item.materialName}}</td>
                  <td style="text-align: center;">{{constant.locationNo[item.location]}}</td>
                  <td style="text-align: center;">{{item.locationSumQty}}</td>
                  <td style="text-align: center;">{{item.supplierSumQty}}</td>
                  <td style="text-align: center;">{{item.sumQty}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import barCode from "jsbarcode";
  import constant from "@/util/constant";
  export default {
    data() {
      return {
        ids: [],
        contentLoading: false,
        constant,
        productionOrderList: [],
        printType: 1, // 1: 生产单打印 2: 生产领料打印
        printPkid: "",
      };
    },

    mounted() {
      this.printType = Number(this.$route.query.printType);
      this.printPkid = JSON.parse(this.$route.query.ids);
      this.getData(this.printPkid);
    },

    methods: {
      getData(ids) {
        this.productionOrderList = [];
        this.$http.put("basic", "mergeMaterials/getByIds", ids).then((resp) => {
          this.productionOrderList = resp.data;
          this.$nextTick(() => {
            this.productionOrderList.forEach(resp => {
              document.getElementById("qrCode" + resp.billNo).innerHTML = "";
              this.bindQRCode(resp);
            });
          });
        });
      },
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      
      bindQRCode(row) {
        let text = row.billNo;
        new barCode(
          "#qrCode" + text, text,
          {
            displayValue: true, // 是否在条形码下方显示文字
            format: "CODE128",
            height: 40,
          },
        );
      },
      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        // 执行打印
        window.print();
        window.close();
        return false;
      },
    },
  };
  </script>

  <style lang="scss" scoped>
    .printBtnBox {
      width: 195mm; margin: 0 auto; padding: 2mm 0; position: fixed; top: 0; left: -10cm; margin-left: 50%;background-color: #fff;z-index: 999;
    }
    .printContainer {
      width: 195mm;
      margin: 10px auto;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    
    .qrCodeBox {
      border: 1px solid #000;
      display: flex;
      align-items: center;
    }

    .title {
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-weight: 700;
      font-size: 16pt;
      color: #000;
      border-bottom: 1px solid #000;
    }

    .smallTitle {
      font-size: 14pt;
      border-bottom: none;
    }

    /* 表格样式设置 */
    .print-table {
      width: 100%;
      font-size: 9pt;
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif;
      color: #000;
      border-collapse: collapse;
      border: 1px solid #000;
      line-height: 1.2;
    }

    .print-table th,
    .print-table td {
      font-size: 10pt;
      color: #000;
      border: 1px solid #000;
      padding: 2px;
      word-wrap: break-word;
      word-break: break-all;
    }

    .print-table th {
      background-color: #f5f5f5;
      font-weight: bold;
      text-align: center;
      vertical-align: middle;
    }

    /* 物料名称列自动换行 */
    .material-name-col {
      width: 120px;
      max-width: 120px;
      min-width: 120px;
      word-wrap: break-word;
      word-break: break-all;
    }

        
    /* 修复el-descriptions在打印时的显示 */
    ::v-deep .el-descriptions--mini{
      font-size: 10pt;
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      font-weight: normal; // 确保字体粗细适中
      color: #000; // 确保黑色打印
      border-color: #000;
    }
    ::v-deep .el-descriptions-item__label.is-bordered-label{
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      font-weight: normal; // 确保字体粗细适中
      color: #000; // 确保黑色打印
      border-color: #000;
    }
    ::v-deep .el-descriptions__body{
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      font-weight: normal; // 确保字体粗细适中
      color: #000; // 确保黑色打印
      border-color: #000;
    }
    ::v-deep .el-descriptions--mini.is-bordered .el-descriptions-item__cell{
      padding: 2px;
      border-color: #000;
      line-height: 1.2;
    }
    ::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell{
      border-color: #000;
    }
    ::v-deep .el-descriptions-item__content{
      min-width: 100px;
    }
    .printContent{
      width: 195mm; margin: 2mm auto; padding-top: 50px;
    }
    // 打印专用样式优化
    @media print {
      .printContainer {
        margin: 0;
      }
      .dataList {
        page-break-inside: avoid; // 避免在打印项内部分页
      }
      // 只在打印项之间添加分页符，而不是在最后一个打印项之后
      .dataList:not(:last-child) {
        page-break-after: always;
      }
      .printBtnBox{
        display: none;
      }
      .printContent {
        padding-top: 0;
      }
    }
  </style>